export const fixPrice = (price) => {
  return new Intl.NumberFormat("en-GB", { minimumFractionDigits: 2 }).format(
    price
  );
};
